import React from 'react';
import ListsCollapsibleSection from './ListsCollapsibleSection';

/**
 * Sección colapsable "LISTAS COMPARTIDAS CONMIGO".
 */
export default function SharedWithMeListsSection({
  expanded,
  onToggle,
  hasItems,
  emptyContent,
  fillHeight = false,
  children,
}) {
  return (
    <ListsCollapsibleSection
      title="LISTAS COMPARTIDAS CONMIGO"
      expanded={expanded}
      onToggle={onToggle}
      hasItems={hasItems}
      emptyContent={emptyContent}
      fillHeight={fillHeight}
    >
      {children}
    </ListsCollapsibleSection>
  );
}
